import { createRootRoute, Link, Outlet } from "@tanstack/react-router";
import { Toaster } from "sonner";

/**
 * Root route. The component renders the route tree via <Outlet />
 * plus the toast surface (per canon 01-ui/feedback-states.md R5).
 *
 * `notFoundComponent` per docs/design-canon/01-ui/navigation.md R7
 * + 01-ui/feedback-states.md R6: any unmatched route renders a
 * friendly page with a link back, rather than a blank screen or
 * raw "Not Found" string.
 */
export const rootRoute = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return (
    <>
      <Outlet />
      {/* One <Toaster /> mounted at the root surfaces every
          toast.success(...), toast.error(...), etc. call. Top-right
          placement on desktop, top-center on mobile per Sonner default. */}
      <Toaster richColors closeButton position="top-right" />
    </>
  );
}

function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-3xl font-bold text-fg">Page not found</h1>
      <p className="max-w-md text-sm text-fg-subtle">
        The page you&rsquo;re looking for doesn&rsquo;t exist or has moved.
      </p>
      <Link
        to="/dashboard"
        className="rounded-md bg-brand px-4 py-2 text-sm font-medium text-brand-fg hover:bg-brand-deep"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
